import { render } from "./Contacts.vue?vue&type=template&id=91aec2f4&scoped=true"
const script = {}

import "./Contacts.vue?vue&type=style&index=0&id=91aec2f4&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/spark-cabinet-redesigned/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91aec2f4"]])

export default __exports__